export enum TimerEvent {
	TIMER_ON = 'timer_on',
	TIMER_OFF = 'timer_off',
	APPLET_MUTE_ON = 'applet_mute_on',
	APPLET_MUTE_OFF = 'applet_mute_off',
}

export enum DisplayEvent {
	POWER_ON = 'power_on',
	POWER_OFF = 'power_off',
}

export type TimerListener = () => void;

export default interface IProprietaryResolver<T> {
	on(event: T, listener: TimerListener): this;
	getNextTimerOnTime?(): Date | null;
}
